import { BACKEND_URL, get, post } from '../../../../util/api'
import * as type from './type'
import * as selector from './selector'
import Globals from '../../../globals'
import { PRODUCT_TYPE_ALIGNERS, PRODUCT_TYPE_IMPLANTS } from './const'

export const openPreviewModal = () => ({
    type: type.OPEN_PREVIEW_MODAL,
})

export const closePreviewModal = () => ({
    type: type.CLOSE_PREVIEW_MODAL,
})

export const processTaskLoaded = salesOrder => ({
    type: type.PROCESS_TASK_CUSTOMER_LOADED,
    payload: {
        salesOrder,
    },
})

export const customerLoaded = customer => ({
    type: type.CUSTOMER_LOADED,
    payload: {
        customer,
    },
})

export const findOrCreateTreatmentQuotationRequest = () => ({
    type: type.FIND_OR_CREATE_TREATMENT_QUOTATION_REQUEST,
})

export const findOrCreateTreatmentQuotationSuccess = treatmentQuotation => ({
    type: type.FIND_OR_CREATE_TREATMENT_QUOTATION_SUCCESS,
    payload: {
        treatmentQuotation,
    },
})

export const findOrCreateTreatmentQuotationError = error => ({
    type: type.FIND_OR_CREATE_TREATMENT_QUOTATION_ERROR,
    payload: {
        error,
    },
})

function pickUrlByProductType (productType) {
    if (productType === PRODUCT_TYPE_ALIGNERS) {
        return '/api/treatment/quotation/find-by-customer-id'
    }
    if (productType === PRODUCT_TYPE_IMPLANTS) {
        return '/api/implant-treatment/quotation/find-by-customer-id'
    }

    throw new Error('Unknown product type')
}

export const findOrCreateTreatmentQuotation = (productType) => (dispatch, getState) => {
    const state = getState()
    const customerId = selector.selectCustomerId(state)
    const funnelId = selector.selectFunnelId(state)
    if (!customerId) {
        return
    }
    dispatch(findOrCreateTreatmentQuotationRequest())

    const url = pickUrlByProductType(productType)

    get(`${url}?customerId=${customerId}&funnelId=${funnelId}`)
        .then(treatmentQuotation => {
            dispatch(findOrCreateTreatmentQuotationSuccess(treatmentQuotation))
        })
        .catch(error => {
            dispatch(findOrCreateTreatmentQuotationError(error))
        })
}

export const changeTreatmentQuotation = (name, value) => ({
    type: type.CHANGE_TREATMENT_QUOTATION,
    payload: {
        name,
        value,
    },
})
export const changeTreatmentPackagePrice = value => ({
    type: type.CHANGE_TREATMENT_PACKAGE_PRICE,
    payload: {
        value,
    },
})
export const setEditableForUser = () => ({
    type: type.SET_EDITABLE_FOR_USER,
})

export const updatePackageAndPrice = ({ treatmentQuotation, customer }) => (
    dispatch,
    getState,
) => {
    const { countryCode } = customer
    const {
        numberOfAlignerLowerJaw,
        numberOfAlignerUpperJaw,
    } = treatmentQuotation
    get(
        `/api/treatment/calculate-package?numberOfAlignerUpperJaw=${parseInt(numberOfAlignerUpperJaw, 10)}` +
            `&numberOfAlignerLowerJaw=${parseInt(numberOfAlignerLowerJaw, 10)}&treatmentQuotationId=${treatmentQuotation.id}` +
            `&countryCode=${countryCode}`
    )
        .then(packageAndPrice => {
            const { packageSize, price } = packageAndPrice && packageAndPrice[0]
            const confirmUpdate = window.confirm(
                `Are you sure you want to update with \n\n New Package: ${packageSize} \n\n New Price: ${price} `,
            )

            if (confirmUpdate === true) {
                dispatch(changeTreatmentPackagePrice({ packageSize, price }))
                dispatch(saveTreatmentQuotation())
            }
        })
        .catch(error => {
            console.log(error)
        })
}

export const saveTreatmentQuotationRequest = () => ({
    type: type.SAVE_TREATMENT_QUOTATION_REQUEST,
})

export const saveTreatmentQuotationSuccess = treatmentQuotation => ({
    type: type.SAVE_TREATMENT_QUOTATION_SUCCESS,
    payload: {
        treatmentQuotation,
    },
})

export const saveTreatmentQuotationError = error => ({
    type: type.SAVE_TREATMENT_QUOTATION_ERROR,
    payload: {
        error,
    },
})

export const saveTreatmentQuotation = () => (dispatch, getState) => {
    const state = getState()
    const hasChanged = selector.selectHasChanged(state)
    if (!hasChanged) {
        return
    }

    const treatmentQuotation = selector.selectTreatmentQuotation(state)
    dispatch(saveTreatmentQuotationRequest())
    post('/api/treatment/quotation/save', treatmentQuotation)
        .then(treatmentQuotation => {
            dispatch(saveTreatmentQuotationSuccess(treatmentQuotation))
        })
        .catch(error => {
            dispatch(saveTreatmentQuotationError(error))
        })
}

export const saveImplantTreatmentQuotation = () => (dispatch, getState) => {
    const state = getState()
    const hasChanged = selector.selectHasChanged(state)
    if (!hasChanged) {
        return
    }

    const treatmentQuotation = selector.selectTreatmentQuotation(state)
    dispatch(saveTreatmentQuotationRequest())
    post('/api/implant-treatment/quotation/save', treatmentQuotation)
        .then(treatmentQuotation => {
            dispatch(saveTreatmentQuotationSuccess(treatmentQuotation))
        })
        .catch(error => {
            dispatch(saveTreatmentQuotationError(error))
        })
}

export const uploadVideoFileRequest = () => ({
    type: type.UPLOAD_SCAN_VIDEO_REQUEST,
})

export const uploadVideoFileError = error => ({
    type: type.UPLOAD_SCAN_VIDEO_ERROR,
    payload: {
        error,
    },
})

export const uploadVideoFileSuccess = (file, frontendUrl) => ({
    type: type.UPLOAD_SCAN_VIDEO_SUCCESS,
    payload: {
        file,
        frontendUrl,
    },
})

export const uploadVideoFile = (file, treatmentQuotationId) => (
    dispatch,
    getState,
) => {
    const state = getState()
    const frontendUrl = Globals.selector.selectFrontendUrl(state)
    dispatch(uploadVideoFileRequest())

    const data = new FormData()
    data.append('file', file)

    fetch(
        BACKEND_URL +
        '/api/treatment/add-video-file?treatmentQuotationId=' +
        treatmentQuotationId,
        {
            method: 'post',
            body: data,
            headers: {
                Accept: 'application/json',
            },
            credentials: 'include',
        },
    )
        .then(response => {
            return response.json()
        })
        .then(file => {
            dispatch(uploadVideoFileSuccess(file, frontendUrl))
            dispatch(saveTreatmentQuotation())
        })
        .catch(error => {
            dispatch(uploadVideoFileError(error))
        })
}



// WEBPACK FOOTER //
// ./src/modules/treatment/state/quotation/action.js